/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateActiveLanguagesMutationRequest,
  UpdateActiveLanguagesMutationResponse,
  UpdateActiveLanguagesPathParams,
} from "../types/UpdateActiveLanguages.ts"

export const updateActiveLanguagesMutationKey = () =>
  [
    {
      url: "/v1/organization-settings/update-active-languages/:productSheetGroupId",
    },
  ] as const

export type UpdateActiveLanguagesMutationKey = ReturnType<
  typeof updateActiveLanguagesMutationKey
>

/**
 * @summary Update active languages of a ProductSheetGroup
 * {@link /v1/organization-settings/update-active-languages/:productSheetGroupId}
 */
export async function updateActiveLanguages(
  productSheetGroupId: UpdateActiveLanguagesPathParams["productSheetGroupId"],
  data: UpdateActiveLanguagesMutationRequest,
  config: Partial<RequestConfig<UpdateActiveLanguagesMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateActiveLanguagesMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateActiveLanguagesMutationRequest
  >({
    method: "POST",
    url: `/v1/organization-settings/update-active-languages/${productSheetGroupId}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateActiveLanguagesMutationOptions(
  config: Partial<RequestConfig<UpdateActiveLanguagesMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = updateActiveLanguagesMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateActiveLanguagesMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateActiveLanguagesPathParams["productSheetGroupId"]
      data: UpdateActiveLanguagesMutationRequest
    },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ productSheetGroupId, data }) => {
      return updateActiveLanguages(productSheetGroupId, data, config)
    },
  })
}

/**
 * @summary Update active languages of a ProductSheetGroup
 * {@link /v1/organization-settings/update-active-languages/:productSheetGroupId}
 */
export function useUpdateActiveLanguages<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateActiveLanguagesMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        productSheetGroupId: UpdateActiveLanguagesPathParams["productSheetGroupId"]
        data: UpdateActiveLanguagesMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateActiveLanguagesMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateActiveLanguagesMutationKey()

  const baseOptions = updateActiveLanguagesMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateActiveLanguagesMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateActiveLanguagesPathParams["productSheetGroupId"]
      data: UpdateActiveLanguagesMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateActiveLanguagesMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateActiveLanguagesPathParams["productSheetGroupId"]
      data: UpdateActiveLanguagesMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateActiveLanguagesMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateActiveLanguagesPathParams["productSheetGroupId"]
      data: UpdateActiveLanguagesMutationRequest
    },
    TContext
  >
}
